var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"loading-text"},[_c('h1',{staticClass:"loading-title"},[_vm._v("Loading "),_c('i',{staticClass:"fa fa-refresh fa-spin fa-fw"})]),_c('h2',{staticClass:"loading-subtitle"},[_vm._v("This shouldn't take long!")])])])
}]

export { render, staticRenderFns }